import hashJs from 'hash.js';

export const hash = (data: string | Record<string, unknown> | Record<string, unknown>[], length?: number) => {
  return hashJs.sha256().update(JSON.stringify(data)).digest('hex').slice(0, length);
};

export const hashAlpha = (data: string | Record<string, unknown> | Record<string, unknown>[], length?: number) => {
  return hashJs.sha256().update(JSON.stringify(data)).digest('hex').replace(/\d/g, '').slice(0, length);
};
